import React from 'react';
import { browserHistory } from 'react-router';
import PageSpinnerModal from '../../Modals/PageSpinnerModal';

let Quote = require('../../Managers/Quote');
let Policy = require('../../Managers/Policy');
let Payment = require('../../Managers/Payment');
let HttpService = require('../../Managers/HttpService');

const Config = HttpService.getConfigForHost();
const InceptionLoad = React.createClass ({
    getInitialState() {
        return {
            policyNo: null
        };
    },

    componentWillMount() {
        this.setState({
            loading: true
        });

        if (this.state.policyNo != null) {
            this.setState({
                loading:false
            });
        } 

        this.inceptPolicy();
    },

    inceptPolicy() {
        let params = this.props.location.query;

        console.log(params);

        let transactionStatus = Payment.checkTransaction(
            Config.api.transactionLookup.method,
            Config.api.transactionLookup.url,
            params.trans_id
        );

        // TODO poll endpoint in case transaction is not completed
        // while (transactionStatus.transaction.status !== 'COMPLETE') {
        //     setTimeout(function() {
        //         transactionStatus = Payment.checkTransaction(
        //             Config.api.transactionLookup.method,
        //             Config.api.transactionLookup.url,
        //             params.trans_id 
        //         );
        //     }),
        //     250
        // }

        Payment.incept(Config.api.inception.method, Config.api.inception.url, params, transactionStatus)
        .then(
            function(policy){
                policy.title = Quote.getQuote().title;
                policy.firstName = Quote.getQuote().first_name;
                policy.lastName = Quote.getQuote().last_name;
                Policy.cachePolicy(policy);
                if (Policy.get('policy_no')) {
                    browserHistory.push('/success');
                } else {
                    browserHistory.push('/error');
                }
                return false;
            },
            function(error){
                window.localStorage.setItem('policy_error', error);
                browserHistory.push('/error');
            }
        );
    },

    render() {
        return (
            <div>
                {this.state.loading ?
                    <PageSpinnerModal
                        message="Generating your policy..."
                        ref="PageSpinnerModal"
                    />
                : null}
            </div>
        );
    }
});

export default InceptionLoad;



/** WEBPACK FOOTER **
 ** ./src/components/Screens/Payment/InceptionLoad.js
 **/